import React, { useEffect, useState } from "react";
import { LAUNCH_DATE } from "../mock";

const MS_PER_DAY = 86400000;
const MS_PER_HOUR = 3600000;
const MS_PER_MINUTE = 60000;
const MS_PER_SECOND = 1000;

function diff() {
  const target = new Date(LAUNCH_DATE).getTime();
  const now = Date.now();
  let d = Math.max(0, target - now);
  const days = Math.floor(d / MS_PER_DAY); d -= days * MS_PER_DAY;
  const hours = Math.floor(d / MS_PER_HOUR); d -= hours * MS_PER_HOUR;
  const mins = Math.floor(d / MS_PER_MINUTE); d -= mins * MS_PER_MINUTE;
  const secs = Math.floor(d / MS_PER_SECOND);
  return { days, hours, mins, secs };
}

export default function Countdown({ compact = false }) {
  const [t, setT] = useState(diff());

  useEffect(() => {
    const id = setInterval(() => setT(diff()), 1000);
    return () => clearInterval(id);
  }, []);

  const cells = [
    { v: t.days, l: "Days" },
    { v: t.hours, l: "Hrs" },
    { v: t.mins, l: "Min" },
    { v: t.secs, l: "Sec" },
  ];

  return (
    <div className={`flex ${compact ? "gap-2" : "gap-3"}`}>
      {cells.map((c) => (
        <div
          key={c.l}
          className={`rounded-xl border border-[#2fd645]/25 bg-black/50 backdrop-blur-sm text-center ${
            compact ? "px-3 py-2 min-w-[56px]" : "px-4 py-3 min-w-[72px]"
          }`}
        >
          <div className={`font-display font-extrabold text-[#2fd645] ${compact ? "text-xl" : "text-3xl"}`}>
            {String(c.v).padStart(2, "0")}
          </div>
          <div className="text-[10px] uppercase tracking-widest text-white/50">{c.l}</div>
        </div>
      ))}
    </div>
  );
}
